import gql from 'graphql-tag';

export const fields = `
    tenantIds
    companyId
    company {
        id
        hasFileManagerChatbot
        hasSqlChatbot
        tenant
        {
            id
            name
            code
            isActive
        }
    }
    aircraftModelId
    aircraftModel {
        id
        name
        totalMotors
        aircraftStatuses {
            id
            name
        }
    }
    engineModelId
    engineModel {
        id
        name
    }
    fleetTabs {
        id
        name
        type
        link
        sort
        isMaster
        isActive
        
        title
        enginesJoin
        chartTypeId
        chartType {
            id
            value
        }
    }
    hasOpenIssues
    hasAiPredictions
    hasSchedule
    createdAt
    updatedAt
`;

export const relationsFields = `
    digitaiPaginateCompanies (
        query:$queryPaginateCompanies
        constraint:$constraintPaginateCompanies
    ) {
        total
        rows
        count
    }
    digitaiPaginateAircraftModels (
        query:$queryPaginateAircraftModels
        constraint:$constraintPaginateAircraftModels
    ) {
        total
        rows
        count
    }
    digitaiPaginateEngineModels (
        query:$queryPaginateEngineModels
        constraint:$constraintPaginateEngineModels
    ) {
        total
        rows
        count
    }
    digitaiGetChartTypes (
        query:$queryGetChartTypes
        constraint:$constraintGetChartTypes
    ) {
        id
        value
    }
`;
// default methods
export const paginationQuery = gql`
    query DigitaiPaginateFleets (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateFleets (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetFleets (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetFleets (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const getRelations = gql`
    query DigitaiGetFleetsRelations (
        $queryPaginateCompanies: QueryStatement
        $constraintPaginateCompanies: QueryStatement
        $queryPaginateAircraftModels: QueryStatement
        $constraintPaginateAircraftModels: QueryStatement
        $queryPaginateEngineModels: QueryStatement
        $constraintPaginateEngineModels: QueryStatement
        $queryGetChartTypes: QueryStatement
        $constraintGetChartTypes: QueryStatement
    ) {
        ${relationsFields}
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindFleetById (
        $id: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindFleetById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdWithRelationsQuery = gql`
    query DigitaiFindFleetByIdWithRelations (
        $id: ID
        $constraint: QueryStatement
        $queryPaginateCompanies: QueryStatement
        $constraintPaginateCompanies: QueryStatement
        $queryPaginateAircraftModels: QueryStatement
        $constraintPaginateAircraftModels: QueryStatement
        $queryPaginateEngineModels: QueryStatement
        $constraintPaginateEngineModels: QueryStatement
        $queryPaginateFleetTabs: QueryStatement
        $constraintPaginateFleetTabs: QueryStatement
        $queryPaginateFleetAircrafts: QueryStatement
        $constraintPaginateFleetAircrafts: QueryStatement
        $queryGetChartTypes: QueryStatement
        $constraintGetChartTypes: QueryStatement
    ) {
        object: digitaiFindFleetById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
        digitaiPaginateFleetTabs (
            query: $queryPaginateFleetTabs
            constraint: $constraintPaginateFleetTabs
        ) {
            total
            rows
            count
        }
        digitaiPaginateFleetAircrafts (
            query: $queryPaginateFleetAircrafts
            constraint: $constraintPaginateFleetAircrafts
        ) {
            total
            rows
            count
        }
        ${relationsFields}
    }
`;

export const findByIdWithRelationsOperatorQuery = gql`
    query DigitaiFindFleetByIdWithOperatorRelations (
        $id: ID
        $constraint: QueryStatement
        $queryPaginateAircraftModels: QueryStatement
        $constraintPaginateAircraftModels: QueryStatement
        $queryPaginateEngineModels: QueryStatement
        $constraintPaginateEngineModels: QueryStatement
        $queryPaginateFleetTabs: QueryStatement
        $constraintPaginateFleetTabs: QueryStatement
        $queryPaginateFleetAircrafts: QueryStatement
        $constraintPaginateFleetAircrafts: QueryStatement
    ) {
        object: digitaiFindFleetById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
        digitaiPaginateFleetTabs (
            query: $queryPaginateFleetTabs
            constraint: $constraintPaginateFleetTabs
        ) {
            total
            rows
            count
        }
        digitaiPaginateFleetAircrafts (
            query: $queryPaginateFleetAircrafts
            constraint: $constraintPaginateFleetAircrafts
        ) {
            total
            rows
            count
        }
        digitaiPaginateAircraftModels (
            query:$queryPaginateAircraftModels
            constraint:$constraintPaginateAircraftModels
        ) {
            total
            rows
            count
        }
        digitaiPaginateEngineModels (
            query:$queryPaginateEngineModels
            constraint:$constraintPaginateEngineModels
        ) {
            total
            rows
            count
        }
    }
`;

export const findQuery = gql`
    query DigitaiFindFleet (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindFleet (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const getOverviewGraphQuery = gql`
    mutation DigitaiGetOverviewGraph (
        $payload: DigitaiGetOverviewChart!
    ) {
        digitaiGetOverviewGraph (
            payload: $payload
        ) 
    }
`;


export const createMutation = gql`
    mutation DigitaiCreateFleet (
        $payload: DigitaiCreateFleetInput!
    ) {
        digitaiCreateFleet (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateFleets (
        $payload: [DigitaiCreateFleetInput]!
    ) {
        digitaiCreateFleets (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateFleetById (
        $payload: DigitaiUpdateFleetByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateFleetById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateFleets (
        $payload: DigitaiUpdateFleetsInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateFleets (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteFleetById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteFleetById (
            id: $id
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteFleets (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteFleets (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

// Mutation additionalApis
export const sendMessageFleetMutation = gql`
    mutation DigitaiSendMessageFleet (
        $payload: DigitaiCreateFleetMessageInput!
    ) {
        digitaiSendMessageFleet (
            payload: $payload
        )
    }
`;
